import { ConfigService } from "src/app/services/config.service";
import { environment } from "src/environments/environment";


export class Constants {

        // Runtime config service instance (set by AppComponent)
    private static _configService: ConfigService;
    
    /**
     * Initialize Constants with ConfigService
     * Call this in app.component.ts constructor
     */
    static initializeConfig(configService: ConfigService) {
        Constants._configService = configService;
    }
    
    /**
     * Get runtime config with fallback to environment.ts
     */
    private static getRuntimeConfig() {
        if (Constants._configService) {
            const config = Constants._configService.getConfig();
            if (config) {
                return config;
            }
        }
        // Fallback to environment.ts during initialization
        return environment;
    }

    static AUTH_TOKEN = 'auth_token';
    static Refresh_TOKEN = 'refresh_token';
    static CURRENT_GROUP = 'group';
    static CURRENT_GROUP_CODE = 'group-code';
    static CURRENT_PLANT_CODE = 'plant-code';
    static CURRENT_PLANT = 'plant';
    static LOGGED_IN_USER = 'logged_in_user';
    static USER_MENUS = 'user_menus';
    static USER_PERMISSIONS = 'user_permissions';
    static USER_CONFIGURATIONS = 'user_configurations';
    static USER_CHATBOT_CONFIGURATIONS = 'user_chatbot_configurations';
    static MENU_CARDS = 'menu_cards';
    static PARENT_MENU = 'current_parent_menu';
    static CHILD_MENU = 'child_menu';
    static CURRENT_MENU_ID = 'current_menu_id';
    static APP_LANGUAGE_COOKIE_KEY = 'appLang';
    static PAGE_SIZE = 10;
    static PAGE_OPTIONS = [5, 10, 20, 50];
    static NOTIFICATION_LIMIT = 10;
    static Language_Name = 'Language_Name';

    // hashing query params algorithem values
    static HASH_ALGORITHEM = 'aes-256-cbc';
    static HASH_KEY = 'LzZW6SAJ69815rfonK5hY5qoMAN901S8';
    static HASH_IV = 'xQjgGhynmacXqAyk';
    
    static get API_BASE_URL(): string {
        return Constants.getRuntimeConfig().api_baseurl || environment.api_baseurl;
    }
     static get CORE_APPLICATION_URL(): string {
        return Constants.getRuntimeConfig().core_app_url || environment.core_app_url;
    }
    api_baseurl
    // static UI_BUILDER_APPLICATION_URL = environment.uiBuilder_app_url;
    // static UTILITY_APPLICATION_URL = environment.utility_app_url;

    static get LEAN_API_URL(): string {
        return Constants.getRuntimeConfig().leanApiUrl || environment.leanApiUrl;
    }
    static get API_BASE_URL_UTILITY(): string {
        return Constants.getRuntimeConfig().api_baseurlUty || environment.api_baseurlUty;
    }
    
    static get UI_BUILDER_APPLICATION_URL(): string {
        return Constants.getRuntimeConfig().uiBuilder_app_url || environment.uiBuilder_app_url;
    }
    
    static get UTILITY_APPLICATION_URL(): string {
        return Constants.getRuntimeConfig().utility_app_url || environment.utility_app_url;
    }




    static USER_DEVICE_KEY = 'UDK';
    // loading labels
    static LOADING_DATA = 'Refreshing';



    static get API_VERSION(): string {
        return Constants.getRuntimeConfig().api_version || environment.api_version;
    }
    
    static get CORE_API_BASE_URL(): string {
        return Constants.getRuntimeConfig().O3CoreApiUrl || environment.O3CoreApiUrl;
    }
    
    static get API_SIGNALR_BASE_URL(): string {
        return Constants.getRuntimeConfig().api_signalR_baseUrl || environment.api_signalR_baseUrl;
    }
    
    static get API_PREFIX(): string {
        return Constants.getRuntimeConfig().api_prefix || environment.api_prefix;
    }
    

        static get WORKFLOW_API_URL(): string {
        return Constants.getRuntimeConfig().workFLowApi || environment.workFLowApi;
    }
    
    // Additional runtime configuration properties
    static get BLOB_STORAGE_URL(): string {
        return Constants.getRuntimeConfig().blobStorageUrl || environment.blobStorageUrl;
    }

    static readonly PLACEHOLDER_ELEMENT_ID = '2352352353';
    
    static get O3_IMAGE_URL(): string {
        const config: any = Constants.getRuntimeConfig();
        return (config && config.O3ImageUrl) || (environment as any).O3ImageUrl || '';
    }
    
    static get IMAGE_URL(): string {
        const config: any = Constants.getRuntimeConfig();
        return (config && config.ImageUrl) || (environment as any).ImageUrl || '';
    }
    
    static get LLM_REQUEST_URL(): string {
        return Constants.getRuntimeConfig().LLMRequestUrl || environment.LLMRequestUrl;
    }



        static get FIREBASE_CONFIG(): any {
        return Constants.getRuntimeConfig().firebaseConfig || environment.firebaseConfig;
    }
    
    static get COMPANY_KEY(): string {
        return Constants.getRuntimeConfig().companyKey || environment.companyKey;
    }
    
    static get TOKEN(): string {
        const config: any = Constants.getRuntimeConfig();
        return (config && config.token) || (environment as any).token || '';
    }
    
    static get VERSION(): string {
        return Constants.getRuntimeConfig().version || environment.version;
    }
    
    static get WHITE_LISTED_DOMAINS(): string[] {
        const domains = Constants.getRuntimeConfig().white_listed_Domains || environment.white_listed_Domains;
        return Array.isArray(domains) ? domains : [domains];
    }
    
    static get API_WORKFLOW_BASEURL(): string { return ''; }
    static WORK_FLOW_COMPANY_KEY = '';

    // static API_BASE_URL_GENERAL = Constants.API_BASE_URL + Constants.API_PREFIX;
    static get API_BASE_URL_GENERAL(): string {
        return Constants.CORE_API_BASE_URL;
    }
    
    static get API_BASE_URL_UTILITY_GENERAL(): string {
        return Constants.API_BASE_URL_UTILITY;
    }



    // api routes configurations
    // static API_VERSION = environment.api_version;
    // // static API_BASE_URL = environment.api_baseurl;
    // static CORE_API_BASE_URL = environment.O3CoreApiUrl;
    // static API_SIGNALR_BASE_URL = environment.api_signalR_baseUrl;
    // static API_PREFIX = environment.api_prefix;
    // static API_BASE_URL_UTILITY = environment.api_baseurlUty;
    // static API_WORKFLOW_BASEURL = '';
    // static WORK_FLOW_COMPANY_KEY = '';

    // // static API_BASE_URL_GENERAL = Constants.API_BASE_URL + Constants.API_PREFIX;
    // static API_BASE_URL_GENERAL = Constants.CORE_API_BASE_URL;
    // static API_BASE_URL_UTILITY_GENERAL = Constants.API_BASE_URL_UTILITY;

    // static API_SIGN_IN = Constants.API_BASE_URL_GENERAL + 'auth/signIn';

    static get API_SIGN_IN(): string {return Constants.API_BASE_URL_GENERAL + 'auth/signIn'; }
    static get API_SIGN_IN_WITH_PLANT_ADMIN(): string { return Constants.API_BASE_URL_GENERAL + 'auth/signInWithPlantAdmin'; }
    static get API_SIGN_IN_SWITCH_ACCOUNT(): string { return Constants.API_BASE_URL_GENERAL + 'auth/switchAccount'; }
    static get API_SIGN_IN_USER_USING_TOKEN(): string { return Constants.API_BASE_URL_GENERAL + 'auth/signInWithUserUsingToken';}
    static get API_SIGN_IN_USER(): string { return Constants.API_BASE_URL_GENERAL + 'auth/signInWithUser'; }
    static get API_REFRESH_TOKEN(): string { return Constants.API_BASE_URL_GENERAL + 'auth/refreshToken'; }
    static get API_CONFIRM_EMAIL(): string { return Constants.API_BASE_URL_GENERAL + 'auth/verifyAccount'; }
    static get API_FORGOT_PASSWORD(): string { return Constants.API_BASE_URL_GENERAL + 'auth/forgotPassword'; }
    static get API_RESET_PASSWORD(): string { return Constants.API_BASE_URL_GENERAL + 'auth/resetPassword'; }
    static get API_RESEND_VERIFICATION_CODE(): string { return Constants.API_BASE_URL_GENERAL + 'auth/resetVerificationToken'; }
    static get API_RESEND_VERIFICATION_CODE_PLANT(): string { return Constants.API_BASE_URL_GENERAL + 'auth/resetVerificationTokenForPlant'; }
    static get API_RESEND_VERIFICATION_CODE_GROUP(): string { return Constants.API_BASE_URL_GENERAL + 'auth/resetVerificationTokenForGroup'; }
    static get API_CHANGE_USER_PROFILE(): string { return Constants.API_BASE_URL_GENERAL + 'auth/changeUserProfile'; }
    static get API_CHANGE_USER_EMAIL(): string { return Constants.API_BASE_URL_GENERAL + 'auth/changeUserEmail'; }

    // Common API
    // static API_GET_GROUP_DATA = Constants.API_BASE_URL_UTILITY_GENERAL + 'Common/GetGroup';
    // static API_GET_LINE_BY_PLANT_AND_USER_CODE = Constants.API_BASE_URL_UTILITY_GENERAL + 'Common/GetLineByPlantAndUserCode';
    // static API_GET_LINE_BY_PLANT_CODE = Constants.API_BASE_URL_UTILITY_GENERAL + 'Common/GetLineByPlantCode';
    // static API_GET_UNITS_BY_LINE_ID = Constants.API_BASE_URL_UTILITY_GENERAL + 'Common/GetUnitsByLineId';

    static get API_GET_GROUP_DATA(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Common/GetGroup'; }
    static get API_GET_LINE_BY_PLANT_AND_USER_CODE(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Common/GetLineByPlantAndUserCode'; }
    static get API_GET_LINE_BY_PLANT_CODE(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Common/GetLineByPlantCode'; }
    static get API_GET_UNITS_BY_LINE_ID(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Common/GetUnitsByLineId'; }



    // Utility parameter API

    // static API_GET_UTILITY_PARAMETER_GROUP = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetVariableGroupList';
    // static API_GET_UTILITY_PARAMETER = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetVariableList';
    // static API_GET_UTILITY_PARAMETER_SPECS = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetParameterSpecificationsList';
    // static API_ADD_UTILITY_PARAMETER_GROUP = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/SumbitGroup';
    // static API_GET_PREDEFINED_PARAM = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetPredefinedParameter';
    // static API_GET_PARAM_GROUP_LIST = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetVariableGroupList';
    // static API_GET_VARIABLE_LIST = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetVariableList';
    // static API_SUBMIT_PARAM_SPECS = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/SumbitParameterSpecifications';
    // static API_DELETE_PARAM_SPECS = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/DeleteVariableParameterSpec';
    // static API_GET_DATA_TYPE = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetDataType';
    // static API_GET_DATA_SOURCE = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetDatasource';
    // static API_GET_INPUT_TAG = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetInputTag';
    // static API_GET_CALCULATION_METHOD = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetCalculationMethod';
    // static API_SUBMIT_VARIABLES = Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/SumbitVaraibles';
    // static API_GET_ALL_DATA_TYPE_IDS = Constants.API_BASE_URL_UTILITY_GENERAL + 'VariableParameterGroup/GetAllDataTypeIds';
    // static API_CHATBOT_CONFIGURATIONS_GET = Constants.API_BASE_URL_GENERAL + 'userChatbotConfiguration/getUserChatbotConfiguration';

    static get API_GET_UTILITY_PARAMETER_GROUP(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetVariableGroupList'; }
    static get API_GET_UTILITY_PARAMETER(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetVariableList'; }
    static get API_GET_UTILITY_PARAMETER_SPECS(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetParameterSpecificationsList'; }
    static get API_ADD_UTILITY_PARAMETER_GROUP(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/SumbitGroup'; }
    static get API_GET_PREDEFINED_PARAM(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetPredefinedParameter'; }
    static get API_GET_PARAM_GROUP_LIST(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetVariableGroupList'; }
    static get API_GET_VARIABLE_LIST(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetVariableList'; }
    static get API_SUBMIT_PARAM_SPECS(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/SumbitParameterSpecifications'; }
    static get API_DELETE_PARAM_SPECS(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/DeleteVariableParameterSpec'; }
    static get API_GET_DATA_TYPE(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetDataType'; }
    static get API_GET_DATA_SOURCE(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetDatasource'; }
    static get API_GET_INPUT_TAG(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetInputTag'; }
    static get API_GET_CALCULATION_METHOD(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/GetCalculationMethod'; }
    static get API_SUBMIT_VARIABLES(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'Variable/SumbitVaraibles'; }
    static get API_GET_ALL_DATA_TYPE_IDS(): string { return Constants.API_BASE_URL_UTILITY_GENERAL + 'VariableParameterGroup/GetAllDataTypeIds'; }
    static get API_CHATBOT_CONFIGURATIONS_GET(): string { return Constants.API_BASE_URL_GENERAL + 'userChatbotConfiguration/getUserChatbotConfiguration'; }


    // GROUP ROUTES
    // static API_GETALL_GROUPS = Constants.API_BASE_URL_GENERAL + 'group/getAllGroups';
    // static API_GROUP_CREATE = Constants.API_BASE_URL_GENERAL + 'group/createGroup';
    // static API_GROUP_EDIT = Constants.API_BASE_URL_GENERAL + 'group/editGroup';
    // static API_GROUP_BY_ID = Constants.API_BASE_URL_GENERAL + 'group/getGroupById';
    // static API_GROUP_DETAILS = Constants.API_BASE_URL_GENERAL + 'group/getGroupDetails';
    // static API_GROUP_ACTIVATE = Constants.API_BASE_URL_GENERAL + 'group/activate';
    // static API_GROUP_DEACTIVATE = Constants.API_BASE_URL_GENERAL + 'group/deactivate';

    static get API_GETALL_GROUPS(): string { return Constants.API_BASE_URL_GENERAL + 'group/getAllGroups'; }
    static get API_GROUP_CREATE(): string { return Constants.API_BASE_URL_GENERAL + 'group/createGroup'; }
    static get API_GROUP_EDIT(): string { return Constants.API_BASE_URL_GENERAL + 'group/editGroup'; }
    static get API_GROUP_BY_ID(): string { return Constants.API_BASE_URL_GENERAL + 'group/getGroupById'; }
    static get API_GROUP_DETAILS(): string { return Constants.API_BASE_URL_GENERAL + 'group/getGroupDetails'; }
    static get API_GROUP_ACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'group/activate'; }
    static get API_GROUP_DEACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'group/deactivate'; }
 

    // features routes
    static get API_FEATURES(): string { return Constants.API_BASE_URL_GENERAL + 'feature/getAllFeatures'; }
    static get API_FEATURES_BY_VARIENTS(): string { return Constants.API_BASE_URL_GENERAL + 'feature/getFeaturesByVarients'; }
    static get API_FEATURES_BY_GRP(): string { return Constants.API_BASE_URL_GENERAL + 'feature/getFeaturesByGroup'; }
    static get API_FEATURES_BY_PLANT(): string { return Constants.API_BASE_URL_GENERAL + 'feature/getFeaturesByPlant'; }

    // user routes
    // static API_USER_PROFILE = Constants.API_BASE_URL_GENERAL + 'user/getUserProfile';
    // static API_USERS_BY_PLANT = Constants.API_BASE_URL_GENERAL + 'user/getUsersByPlant';
    // static API_USER_CHANGE_PHOTO = Constants.API_BASE_URL_GENERAL + 'user/changeUserPhoto';
    // static API_USERS_LAZYLOADED = Constants.API_BASE_URL_GENERAL + 'user/getLazyLoadedUsers';
    // static API_USER_CREATE = Constants.API_BASE_URL_GENERAL + 'user/createUser';
    // static API_USER_UPDATE = Constants.API_BASE_URL_GENERAL + 'user/updateUser';
    // static API_USER_ACTIVATE = Constants.API_BASE_URL_GENERAL + 'user/activate';
    // static API_USER_DEACTIVATE = Constants.API_BASE_URL_GENERAL + 'user/deactivate';
    // static API_USER_DELETE = Constants.API_BASE_URL_GENERAL + 'user/deleteUser';
    // static API_USER_DETAILS = Constants.API_BASE_URL_GENERAL + 'user/getUserDetails';
    // static API_USER_SAVE_PERMISSIONS = Constants.API_BASE_URL_GENERAL + 'user/saveUserPermissions';
    // static API_USER_PLANTS_SWITCH_ACCOUNT = Constants.API_BASE_URL_GENERAL + 'user/getUserPlantsForSwitchAccount';
    // static API_DELETED_USERS = Constants.API_BASE_URL_GENERAL + 'user/getDeletedUsers';
    // static API_DELETED_USERS_REVERSE = Constants.API_BASE_URL_GENERAL + 'user/reverseDeletedUser';
    // static API_USER_GET_CONFIGURATION = Constants.API_BASE_URL_GENERAL + 'user/getUserConfiguration';
    // static API_USER_CREATE_CONFIGURATION = Constants.API_BASE_URL_GENERAL + 'user/addUserConfiguration';
    // static API_USER_UPDATE_CONFIGURATION = Constants.API_BASE_URL_GENERAL + 'user/updateUserConfiguration';
    // static API_USER_RESET_CONFIGURATION = Constants.API_BASE_URL_GENERAL + 'user/resetUserConfiguration';


    static get API_USER_PROFILE(): string { return Constants.API_BASE_URL_GENERAL + 'user/getUserProfile'; }
    static get API_USERS_BY_PLANT(): string { return Constants.API_BASE_URL_GENERAL + 'user/getUsersByPlant'; }
    static get API_USER_CHANGE_PHOTO(): string { return Constants.API_BASE_URL_GENERAL + 'user/changeUserPhoto'; }
    static get API_USERS_LAZYLOADED(): string { return Constants.API_BASE_URL_GENERAL + 'user/getLazyLoadedUsers'; }
    static get API_USER_CREATE(): string { return Constants.API_BASE_URL_GENERAL + 'user/createUser'; }
    static get API_USER_UPDATE(): string { return Constants.API_BASE_URL_GENERAL + 'user/updateUser'; }
    static get API_USER_ACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'user/activate'; }
    static get API_USER_DEACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'user/deactivate'; }
    static get API_USER_DELETE(): string { return Constants.API_BASE_URL_GENERAL + 'user/deleteUser'; }
    static get API_USER_DETAILS(): string { return Constants.API_BASE_URL_GENERAL + 'user/getUserDetails'; }
    static get API_USER_SAVE_PERMISSIONS(): string { return Constants.API_BASE_URL_GENERAL + 'user/saveUserPermissions'; }
    static get API_USER_PLANTS_SWITCH_ACCOUNT(): string { return Constants.API_BASE_URL_GENERAL + 'user/getUserPlantsForSwitchAccount'; }
    static get API_DELETED_USERS(): string { return Constants.API_BASE_URL_GENERAL + 'user/getDeletedUsers'; }
    static get API_DELETED_USERS_REVERSE(): string { return Constants.API_BASE_URL_GENERAL + 'user/reverseDeletedUser'; }
    static get API_USER_GET_CONFIGURATION(): string { return Constants.API_BASE_URL_GENERAL + 'user/getUserConfiguration'; }
    static get API_USER_CREATE_CONFIGURATION(): string { return Constants.API_BASE_URL_GENERAL + 'user/addUserConfiguration'; }
    static get API_USER_UPDATE_CONFIGURATION(): string { return Constants.API_BASE_URL_GENERAL + 'user/updateUserConfiguration'; }
    static get API_USER_RESET_CONFIGURATION(): string { return Constants.API_BASE_URL_GENERAL + 'user/resetUserConfiguration'; }



    // PLANT ROUTES
    // static API_PLANTS_LAZYLOADED_BYGROUP = Constants.API_BASE_URL_GENERAL + 'plant/getLazyLoadedPlantByGroup';
    // static API_PLANTS_GETALL_BYGROUP = Constants.API_BASE_URL_GENERAL + 'plant/getAllPlantsByGroup';
    // static API_PLANT_CREATE = Constants.API_BASE_URL_GENERAL + 'plant/createPlant';
    // static API_PLANT_EDIT = Constants.API_BASE_URL_GENERAL + 'plant/editPlant';
    // static API_PLANT_BY_ID = Constants.API_BASE_URL_GENERAL + 'plant/getPlantById';
    // static API_PLANT_DETAILS = Constants.API_BASE_URL_GENERAL + 'plant/getPlantDetails';
    // static API_PLANT_ACTIVATE = Constants.API_BASE_URL_GENERAL + 'plant/activate';
    // static API_PLANT_DEACTIVATE = Constants.API_BASE_URL_GENERAL + 'plant/deactivate';
    // static API_CURRENCY_DETAILS = Constants.API_BASE_URL_GENERAL + 'user/getCurrencyDetails';

    static get API_PLANTS_LAZYLOADED_BYGROUP(): string { return Constants.API_BASE_URL_GENERAL + 'plant/getLazyLoadedPlantByGroup'; }
    static get API_PLANTS_GETALL_BYGROUP(): string { return Constants.API_BASE_URL_GENERAL + 'plant/getAllPlantsByGroup'; }
    static get API_PLANT_CREATE(): string { return Constants.API_BASE_URL_GENERAL + 'plant/createPlant'; }
    static get API_PLANT_EDIT(): string { return Constants.API_BASE_URL_GENERAL + 'plant/editPlant'; }
    static get API_PLANT_BY_ID(): string { return Constants.API_BASE_URL_GENERAL + 'plant/getPlantById'; }
    static get API_PLANT_DETAILS(): string { return Constants.API_BASE_URL_GENERAL + 'plant/getPlantDetails'; }
    static get API_PLANT_ACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'plant/activate'; }
    static get API_PLANT_DEACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'plant/deactivate'; }
    static get API_CURRENCY_DETAILS(): string { return Constants.API_BASE_URL_GENERAL + 'user/getCurrencyDetails'; }



    // Employee ROUTES
    // static API_EMPLOYEE_LAZYLOADED = Constants.API_BASE_URL_GENERAL + 'employee/getLazyLoadedEmployees';
    // static API_EMPLOYEES_GETALL = Constants.API_BASE_URL_GENERAL + 'employee/getAllEmployees';
    // static API_EMPLOYEES_GETALL_REPORTTO = Constants.API_BASE_URL_GENERAL + 'employee/getAllReportToEmployees';
    // static API_EMPLOYEES = Constants.API_BASE_URL_GENERAL + 'employee/getAllEmployees';
    // static API_EMPLOYEE_CREATE = Constants.API_BASE_URL_GENERAL + 'employee/createEmployee';
    // static API_EMPLOYEE_EDIT = Constants.API_BASE_URL_GENERAL + 'employee/editEmployee';
    // static API_EMPLOYEE_BY_ID = Constants.API_BASE_URL_GENERAL + 'employee/getEmployeeById';
    // static API_EMPLOYEE_BY_CODE = Constants.API_BASE_URL_GENERAL + 'employee/getEmployeeByCode';
    // static API_EMPLOYEE_ACTIVATE = Constants.API_BASE_URL_GENERAL + 'employee/activate';
    // static API_EMPLOYEE_DEACTIVATE = Constants.API_BASE_URL_GENERAL + 'employee/deactivate';
    // static API_EMPLOYEE_DETAILS = Constants.API_BASE_URL_GENERAL + 'employee/getEmployeeDetails';
    // static API_EMPLOYEE_CHANGE_EMAIL = Constants.API_BASE_URL_GENERAL + 'employee/changeEmployeeEmail';
    // static API_ChatBotNextBestAction = Constants.API_BASE_URL_GENERAL + 'employee/getAllChatBotNextBestAction';
    // static API_UpdateReadNextBestAction = Constants.API_BASE_URL_GENERAL + 'employee/updateMessageRead';


    static get API_EMPLOYEE_LAZYLOADED(): string { return Constants.API_BASE_URL_GENERAL + 'employee/getLazyLoadedEmployees'; }
    static get API_EMPLOYEES_GETALL(): string { return Constants.API_BASE_URL_GENERAL + 'employee/getAllEmployees'; }
    static get API_EMPLOYEES_GETALL_REPORTTO(): string { return Constants.API_BASE_URL_GENERAL + 'employee/getAllReportToEmployees'; }
    static get API_EMPLOYEES(): string { return Constants.API_BASE_URL_GENERAL + 'employee/getAllEmployees'; }
    static get API_ChatBotNextBestAction(): string { return Constants.API_BASE_URL_GENERAL + 'employee/getAllChatBotNextBestAction'; }
    static get API_UpdateReadNextBestAction(): string { return Constants.API_BASE_URL_GENERAL + 'employee/updateMessageRead'; }
    static get API_EMPLOYEE_CREATE(): string { return Constants.API_BASE_URL_GENERAL + 'employee/createEmployee'; }
    static get API_EMPLOYEE_EDIT(): string { return Constants.API_BASE_URL_GENERAL + 'employee/editEmployee'; }
    static get API_EMPLOYEE_BY_ID(): string { return Constants.API_BASE_URL_GENERAL + 'employee/getEmployeeById'; }
    static get API_EMPLOYEE_BY_CODE(): string { return Constants.API_BASE_URL_GENERAL + 'employee/getEmployeeByCode'; }
    static get API_EMPLOYEE_ACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'employee/activate'; }
    static get API_EMPLOYEE_DEACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'employee/deactivate'; }
    static get API_EMPLOYEE_DETAILS(): string { return Constants.API_BASE_URL_GENERAL + 'employee/getEmployeeDetails'; }
    static get API_EMPLOYEE_CHANGE_EMAIL(): string { return Constants.API_BASE_URL_GENERAL + 'employee/changeEmployeeEmail'; }




    // departments routes

    // static API_DEPARTMETNS_LAZY_LOADED = Constants.API_BASE_URL_GENERAL + 'department/getAllLazyLoadedDepartments';
    // static API_DEPARTMENT_CREATE = Constants.API_BASE_URL_GENERAL + 'department/createDepartment';
    // static API_DEPARTMENT_EDIT = Constants.API_BASE_URL_GENERAL + 'department/editDepartment';
    // static API_DEPARTMENT_HIERARCHY = Constants.API_BASE_URL_GENERAL + 'department/getDepartmentHierarchy';
    // static API_DEPARTMENT_ACTIVATE = Constants.API_BASE_URL_GENERAL + 'department/activate';
    // static API_DEPARTMENT_DEACTIVATE = Constants.API_BASE_URL_GENERAL + 'department/deactivate';
    // static API_DEPARTMENT_DELETE = Constants.API_BASE_URL_GENERAL + 'department/deleteDepartment';
    // static API_DEPARTMENT_VIEW_HIERARCHY = Constants.API_BASE_URL_GENERAL + 'department/singleDepartmentHierarchy';

    
    static get API_DEPARTMETNS_LAZY_LOADED(): string { return Constants.API_BASE_URL_GENERAL + 'department/getAllLazyLoadedDepartments'; }
    static get API_DEPARTMENT_CREATE(): string { return Constants.API_BASE_URL_GENERAL + 'department/createDepartment'; }
    static get API_DEPARTMENT_EDIT(): string { return Constants.API_BASE_URL_GENERAL + 'department/editDepartment'; }
    static get API_DEPARTMENT_HIERARCHY(): string { return Constants.API_BASE_URL_GENERAL + 'department/getDepartmentHierarchy'; }
    static get API_DEPARTMENT_ACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'department/activate'; }
    static get API_DEPARTMENT_DEACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'department/deactivate'; }
    static get API_DEPARTMENT_DELETE(): string { return Constants.API_BASE_URL_GENERAL + 'department/deleteDepartment'; }
    static get API_DEPARTMENT_VIEW_HIERARCHY(): string { return Constants.API_BASE_URL_GENERAL + 'department/singleDepartmentHierarchy'; }




    // roles routes

    // static API_ROLES_LAZYLOADED = Constants.API_BASE_URL_GENERAL + 'role/getLazyLoadedRoles';
    // static API_ROLES = Constants.API_BASE_URL_GENERAL + 'role/getRoles';
    // static API_ROLE_CREATE = Constants.API_BASE_URL_GENERAL + 'role/createRole';
    // static API_ROLE_EDIT = Constants.API_BASE_URL_GENERAL + 'role/editRole';
    // static API_ROLE_ACTIVATE = Constants.API_BASE_URL_GENERAL + 'role/activate';
    // static API_ROLE_DEACTIVATE = Constants.API_BASE_URL_GENERAL + 'role/deactivate';
    // static API_ROLE_DETAILS = Constants.API_BASE_URL_GENERAL + 'role/getRoleDetails';
    // static API_ROLE_SAVE_PERMISSIONS = Constants.API_BASE_URL_GENERAL + 'role/saveRolePermissions';


    static get API_ROLES_LAZYLOADED(): string { return Constants.API_BASE_URL_GENERAL + 'role/getLazyLoadedRoles'; }
    static get API_ROLES(): string { return Constants.API_BASE_URL_GENERAL + 'role/getRoles'; }
    static get API_ROLE_CREATE(): string { return Constants.API_BASE_URL_GENERAL + 'role/createRole'; }
    static get API_ROLE_EDIT(): string { return Constants.API_BASE_URL_GENERAL + 'role/editRole'; }
    static get API_ROLE_ACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'role/activate'; }
    static get API_ROLE_DEACTIVATE(): string { return Constants.API_BASE_URL_GENERAL + 'role/deactivate'; }
    static get API_ROLE_DETAILS(): string { return Constants.API_BASE_URL_GENERAL + 'role/getRoleDetails'; }
    static get API_ROLE_SAVE_PERMISSIONS(): string { return Constants.API_BASE_URL_GENERAL + 'role/saveRolePermissions'; }



    // user device routes starts
    // static API_USER_DEVICE_CREATE = Constants.API_BASE_URL_GENERAL + 'userDevice/registerUserDevice';
    // static API_USER_DEVICE_EDIT = Constants.API_BASE_URL_GENERAL + 'userDevice/editUserDevice';


    static get API_USER_DEVICE_CREATE(): string { return Constants.API_BASE_URL_GENERAL + 'userDevice/registerUserDevice'; }
    static get API_USER_DEVICE_EDIT(): string { return Constants.API_BASE_URL_GENERAL + 'userDevice/editUserDevice'; }
    // user device routes ends

    // notifications routes starts
    // static API_NOTIFICATIONS = Constants.API_BASE_URL_GENERAL + 'notification/getNotificationsByUser';
    // static API_NOTIFICATION_MARK_AS_READ = Constants.API_BASE_URL_GENERAL + 'notification/markAsReadNotification';
    // static API_NOTIFICATIONS_MARK_ALL_AS_READ = Constants.API_BASE_URL_GENERAL + 'notification/markAllAsReadNotifications';

    static get API_NOTIFICATIONS(): string { return Constants.API_BASE_URL_GENERAL + 'notification/getNotificationsByUser'; }
    static get API_NOTIFICATION_MARK_AS_READ(): string { return Constants.API_BASE_URL_GENERAL + 'notification/markAsReadNotification'; }
    static get API_NOTIFICATIONS_MARK_ALL_AS_READ(): string { return Constants.API_BASE_URL_GENERAL + 'notification/markAllAsReadNotifications'; }


    // notifications routes ends




    // multiple plant request routes starts
    // static API_MULTIPLE_PLANT_REQUESTS = Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/getAllMultiplePlantRequests';
    // static API_USERS_REQUESTS_SENT = Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/getAllUsersRequestsSent';
    // static API_MULTIPLE_PLANT_REQUEST_APPROVE = Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/approveRequest';
    // static API_MULTIPLE_PLANT_REQUEST_REJECT = Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/rejectRequest';
    // static API_MULTIPLE_PLANT_REQUEST_DETAILS = Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/requestDetails';

    static get API_MULTIPLE_PLANT_REQUESTS(): string { return Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/getAllMultiplePlantRequests'; }
    static get API_USERS_REQUESTS_SENT(): string { return Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/getAllUsersRequestsSent'; }
    static get API_MULTIPLE_PLANT_REQUEST_APPROVE(): string { return Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/approveRequest'; }
    static get API_MULTIPLE_PLANT_REQUEST_REJECT(): string { return Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/rejectRequest'; }
    static get API_MULTIPLE_PLANT_REQUEST_DETAILS(): string { return Constants.API_BASE_URL_GENERAL + 'multiplePlantRequest/requestDetails'; }



    // multiple plant request routes ends

    static LEAN_APP_NAME = 'Lean';
    static CORE_APP_NAME = 'Core';
    static UI_FORM_BUILDER_APP_NAME = 'UIBuilder';
    static UTILITY_APP_NAME = 'Utility';
    static MENU_TYPE_LINK = 'link';


    //Default DateTime Settings
    static DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
    static DEFAULT_TIME_FORMAT = 'HH:mm:ss';
}




export enum SupportedPreviewExtensions {
  DOC = '.doc',
  DOCX = '.docx',
  XLSX = '.xlsx',
  XLS = '.xls',
  PDF = '.pdf',
  TXT = '.txt',
  PPTX = '.pptx',
  JPG = '.jpg',
  JPEG = '.jpeg',
  PNG = '.png',
  GIF = '.gif',
  BMP = '.bmp',
  WEBP = '.webp',
  MP4 = '.mp4',
 
  MKV = '.mkv',
  MOV = '.mov',
  
  MP3 = '.mp3',
  WAV = '.wav',
  OGG = '.ogg'
}
export const SUPPORTED_PREVIEW_EXTENSIONS: string[] = Object.values(SupportedPreviewExtensions);

export const FILE_TYPE_GROUPS = {
  IMAGE: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'],
  VIDEO: ['.mp4', '.avi', '.mkv', '.mov', '.wmv'],
  AUDIO: ['.mp3', '.wav', '.ogg'],
  DOCUMENT: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.pptx'],
  ARCHIVE: ['.zip', '.rar'],
  CODE: ['.html', '.css', '.js'],
};

export const ALL_SUPPORTED_FILE_EXTENSIONS: string[] = [
  ...FILE_TYPE_GROUPS.IMAGE,
  ...FILE_TYPE_GROUPS.VIDEO,
  ...FILE_TYPE_GROUPS.AUDIO,
  ...FILE_TYPE_GROUPS.DOCUMENT,
  ...FILE_TYPE_GROUPS.ARCHIVE,
  ...FILE_TYPE_GROUPS.CODE,
];
